import apiService from "../../service/Api";
import {
  CreateResourcePayload,
  PaginatedResources,
  ResourceCategory,
  ResourceItem,
} from "./types";

const ROOT = "/api/resources";

export async function getResourceCategories(): Promise<ResourceCategory[]> {
  const response = await apiService.get<
    ResourceCategory[] | { results: ResourceCategory[] }
  >(`${ROOT}/categories/`);
  return Array.isArray(response.data) ? response.data : response.data.results;
}

export async function createResourceCategory(
  payload: Pick<ResourceCategory, "name" | "slug" | "color"> &
  Partial<Pick<ResourceCategory, "description" | "icon">>,
): Promise<ResourceCategory> {
  const response = await apiService.post<ResourceCategory>(
    `${ROOT}/categories/`,
    { description: "", icon: "folder", ...payload },
  );
  return response.data;
}

export async function getResources(): Promise<ResourceItem[]> {
  const response = await apiService.get<ResourceItem[] | PaginatedResources>(
    `${ROOT}/items/`,
    { ordering: "-is_featured,-updated_at" },
  );
  return Array.isArray(response.data) ? response.data : response.data.results;
}

export async function recordResourceView(id: number): Promise<void> {
  await apiService.post(`${ROOT}/items/${id}/record-view/`);
}

export async function createResource(
  payload: CreateResourcePayload | FormData,
): Promise<ResourceItem> {
  const response = await apiService.post<ResourceItem>(`${ROOT}/items/`, payload);
  return response.data;
}

export async function updateResource(
  id: number,
  payload: CreateResourcePayload,
): Promise<ResourceItem> {
  const response = await apiService.put<ResourceItem>(`${ROOT}/items/${id}/`, payload);
  return response.data;
}

export async function deleteResource(id: number): Promise<void> {
  await apiService.delete(`${ROOT}/items/${id}/`);
}
